module.exports = __webpack_public_path__ + "static/media/urbanEconomy_interIntra_white_logo.123e22e5.svg";